import { gql } from '@apollo/client';

export const SET_FINANCIAL_PROFILE = gql`
  mutation setUserFinancialProfile(
    $investmentPriority: UserInvestmentPriority
    $investmentHorizon: UserInvestmentHorizon
    $downturnReaction: UserDownturnReaction
    $employmentStatus: UserEmploymentStatus
    $employerName: String
    $employerAddressUnitNo: String
    $employerAddressStreet: String
    $employerAddressCity: String
    $employerAddressState: String
    $employerAddressCountry: String
    $employerAddressPostalCode: String
    $occupation: OccupationTitle
    $industry: OccupationIndustry
  ) {
    setUserFinancialProfile(
      input: {
        investmentPriority: $investmentPriority
        investmentHorizon: $investmentHorizon
        downturnReaction: $downturnReaction
        employmentStatus: $employmentStatus
        employerName: $employerName
        employerAddressUnitNo: $employerAddressUnitNo
        employerAddressStreet: $employerAddressStreet
        employerAddressCity: $employerAddressCity
        employerAddressState: $employerAddressState
        employerAddressCountry: $employerAddressCountry
        employerAddressPostalCode: $employerAddressPostalCode
        occupationTitle: $occupation
        occupationIndustry: $industry
      }
    ) {
      id
    }
  }
`;

export const UPDATE_SIP = gql`
  mutation changeRecurringDeposit(
    $sipId: String!
    $amountInCents: Int
    $frequency: SipFrequency
    $pause: Boolean
  ) {
    changeRecurringDeposit(
      input: { sipId: $sipId, amountInCents: $amountInCents, frequency: $frequency, pause: $pause }
    ) {
      id
      recurringDepositInCents
      recurringDepositSchedule
      status
    }
  }
`;
